import { Tag } from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';
import React, { Fragment, useEffect, useState, useRef } from 'react';
import { config } from '../../constant';
import cloneDeep from 'lodash.clonedeep';
import ReactEcharts from '../../Echarts/Echarts';
import { objectOfObject } from '../../../Mock/MockJson';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';

const PieLine = (props) => {
  const [option, setOption] = useState(getOption(props));
  const [refreshDateTime, setRefreshDateTime] = useState(moment());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);
  const requestCheck = useRef(true);
  let timeTicket = useRef(null);
  const abortController = useRef(new window.AbortController());

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    currentTimeZone,
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData();
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear,
    props.translationCache
  ]);
  function getOption() {
    let option = {
      tooltip: {
        trigger: 'axis'
      },
      label: {
        color: props.theme.algorithm === "dark" ? 'white' : 'black',
        fontWeight: 'bold',
        fontSize: 14
      },
      textStyle: {
        color: props.theme.algorithm === "dark" ? 'white' : 'black',
        fontWeight: 'bold',
        fontSize: 18
      },
      legend: {
        left: 'center',
        textStyle: {
          color: props.theme.algorithm === "dark" ? 'white' : 'black'
        }
      },
      toolbox: {
        showTitle: false,
        itemSize: 25,
        feature: {
          saveAsImage: {
            title: 'download',
            name: props.graphprops.title,
            backgroundColor: 'black',
            iconStyle: {
              borderColor: '#8c8c8c',
              borderWidth: 2
            }
          }
        }
      },
      grid: [
        {
          top: '45%',
          width: '90%',
          bottom: '45%',
          left: 50,
          height: '50%',
          containLabel: true
        },
        {
          top: 0,
          width: '50%',
          bottom: '100%',
          left: 0,
          height: '50%',
          containLabel: false
        }
      ],
      xAxis: {
        axisLine: { lineStyle: { color: props.theme.algorithm === "dark" ? 'white' : 'black' } },
        axisTick: { lineStyle: { color: props.theme.algorithm === "dark" ? 'white' : 'black' } },
        axisLabel: { color: props.theme.algorithm === "dark" ? 'white' : 'black' },
        type: 'category'
      },
      yAxis: {
        axisLine: { lineStyle: { color: props.theme.algorithm === "dark" ? 'white' : 'black' } },
        axisTick: { lineStyle: { color: props.theme.algorithm === "dark" ? 'white' : 'black' } },
        axisLabel: { color: props.theme.algorithm === "dark" ? 'white' : 'black' },
        gridIndex: 0
      }
    };
    return option;
  }

  const getData = async () => {
    requestCheck.current = false;
    setErrorInAPI(false);
    setNoDataInDB(false);
    let json = [];
    let { graphprops } = props;
    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = objectOfObject;
      requestCheck.current = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
        }
      }
    }

    if ((json && json.message) || (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)) {
      if (json.message) {
        setErrorInAPI(true);
      } else if (json.length === 0) {
        setNoDataInDB(true);
      }
    } else {
      var pie = json && json.query ? json.query : '';
      var line = json && json.query1 ? json.query1 : [];

      if (line && Array.isArray(line)) {
        let dates = [];
        let values = [];
        let name = '';
        let tagnames = [];
        let series = [];
        let legendsdata = [];

        line.map((val) => {
          if (val.Description !== name) {
            if (tagnames.indexOf(val.Description) === -1) {
              tagnames.push(val.Description);
              name = val.Description;
              legendsdata.push({
                name: val.Description,
                icon: 'roundRect',
                textStyle: {
                  color: props.theme.algorithm === "dark" ? 'white' : 'black',
                  fontSize: 16,
                  fontWeight: 'bold'
                }
              });
            }
          }
          return {};
        });

        let yAxis = {
          axisLine: { lineStyle: { color: props.theme.algorithm === "dark" ? 'white' : 'black' } },
          axisTick: { lineStyle: { color: props.theme.algorithm === "dark" ? 'white' : 'black' } },
          axisLabel: { color: props.theme.algorithm === "dark" ? 'white' : 'black' },
          gridIndex: 0
        };

    tagnames.forEach((tagval, tagindex) => {
      values = [];
      line.forEach((jsonval) => {
        // For first tag, collect dates
        if (tagnames[0] === jsonval.Description && tagindex === 0) {
          if (
            graphprops.monthExists === 'true' ||
            graphprops.monthExists === true
          ) {
            dates.push(
              graphprops && graphprops.type === 'live'
                ? moment
                    .utc(jsonval.DateTime)
                    .tz(currentTimeZone)
                    .format('YYYY-MM-DD')
                : moment
                    .utc(jsonval.DateTime)
                    .tz(currentTimeZone)
                    .format('YYYY-MM-DD')
            );
          } else {
            dates.push(
              graphprops && graphprops.type === 'live'
                ? moment
                    .utc(jsonval.DateTime)
                    .tz(currentTimeZone)
                    .format('YYYY-MM-DD HH:mm:ss')
                : moment
                    .utc(jsonval.DateTime)
                    .tz(currentTimeZone)
                    .format('YYYY-MM-DD HH:mm:ss')
            );
          }
        }
        // Collect values for each tag
        if (tagval === jsonval.Description) {
          values.push(jsonval.Value);
        }
        return {};
          });

          series.push({
            name: legendsdata[tagindex]['name'],
            data: values,

            type: 'line',
            axisLabel: { fontSize: 15 },
            //   areaStyle: {},
            smooth: true
          });
          return {};

        });
        series.push({
          type: 'pie',
          id: 'pie',
          radius: '30%',
          center: ['50%', '25%'],
          label: {
            formatter: ' {b|{c}} ',
            color: '#fff',
            backgroundColor: '#eee',
            borderColor: '#aaa',
            borderWidth: 1,
            borderRadius: 4,
            padding: [0, 4],
            rich: {
              b: {
                fontSize: 14,
                fontWeight: 'bold',
                color: '#fff',
                lineHeight: 22,
                backgroundColor: '#c23531',
                padding: [3, 5],
                borderRadius: 2
              },
              per: {
                fontSize: 14,
                fontWeight: 'bold',
                color: '#fff',
                backgroundColor: '#52c41a',
                padding: [3, 5],
                borderRadius: 2
              }
            }
          },
          data:
            pie &&
            Array.isArray(pie) &&
            pie.map(function (pieData) {
              return {
                name: pieData.Description,
                value: pieData.Value
              };
            })
        });

        const option = cloneDeep(getOption());
        option.xAxis.data = [...dates];
        option.yAxis = { ...yAxis };
        option.series = [...series];
        option.legend = [...legendsdata];
        setOption(option);
        setRefreshDateTime(moment());
        setNoDataInDB(false);
      }
    }
  };

  return (
    <Fragment>
      {props.graphprops && props.graphprops.checked === true ? (
        <Tag className="graphTag" color="blue">
          {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}
      {noDataInDB === true || errorInAPI === true ? (
        noDataInDB === true ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <ReactEcharts
          option={option}
          notMerge={true}
          lazyUpdate={true}
          style={{ height: '90%', width: '100%' }}
          className="react_for_echarts"
        />
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone
  };
};
export default connect(mapStateToProps)(PieLine);

